function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "23",
  height: "19",
  viewBox: "0 0 23 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.48 7.281L1.706 9.138l2.946-.24s-.06-.72.241-1.32c.302-.598.757-1.077 1.38-1.341.621-.264.839-.469.839-.469l-.297-2.346-1.51 2.606L2.598 3.73 4.48 7.28z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: "1.664",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.867 15.39a2.165 2.165 0 11-2.032-3.462s.695.818 1.215 1.346c.52.53 1.23 1.203 1.23 1.203a2.155 2.155 0 01-.413.914z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "1.873",
  cy: "1.873",
  transform: "rotate(37.629 8.769 29.329) skewX(-.001)",
  fill: "#fff",
  r: "1.873"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.936 1.707c1.202.037 2.43.524 3.67 1.48 1.232.95 2.025 1.998 2.396 3.133.373 1.141.274 2.232-.037 3.18-.57 1.74-1.919 3.15-2.603 3.865l-.073.076c-.51.535-.809 1.175-.978 1.71a4.939 4.939 0 00-.181.809 1.305 1.305 0 00-.004.032v.001a1.351 1.351 0 01-1.84 1.151 16.096 16.096 0 01-.5-.21 25.859 25.859 0 01-1.223-.575c-.983-.493-2.281-1.22-3.467-2.134-1.189-.916-2.182-1.957-2.872-2.755-.347-.403-.623-.75-.814-1a13.565 13.565 0 01-.308-.416 1.353 1.353 0 01.6-2.024l.004-.003.04-.017a6.504 6.504 0 00.817-.449c.52-.336 1.048-.787 1.365-1.316l.094-.158c.468-.79 1.427-2.409 2.873-3.423.814-.571 1.835-.993 3.041-.957zm1.483 10.57a.75.75 0 10-1.033-1.087c-.33.313-.83.808-1.19 1.43a7.294 7.294 0 01-1.535-1.195.75.75 0 10-1.06 1.06 8.753 8.753 0 001.883 1.455 5.788 5.788 0 00.788.37c.028.01.057.019.085.027h.001a.75.75 0 00.937-.513c.158-.557.651-1.097 1.124-1.547z",
  fill: "#fff"
})));